// initial state
const state = () => ({
    session: null,
});

// getters
const getters = {
    getSession(state) {
        return state.session;
    },
};

// actions
const actions = {};

// mutations
const mutations = {
    setSession(state, payload) {
        state.session = payload;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
